import React, { ReactElement, useState, useEffect } from 'react';
import { HeadTag } from 'shared/components';
import { Box, Grid, Stack, SvgIcon } from '@mui/material';
import { Formik, useFormikContext } from 'formik';
import ContactPartnerHub from './components/ContactPartnersCard';
import PageHeader from 'shared/components/PageHeader';
import { ReactComponent as Handshake } from 'assets/images/handshake.svg';
import { ReactComponent as Search } from 'assets/images/ic_search.svg';
import {
  AppFormikTextField,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';

const PARTNERS = [
  {
    title: 'Atturra',
    contactLink: 'https://atturra.com/au-en/about/get-in-touch/',
    website: 'https://atturra.com/au-en/',
    description:
      'At Atturra, we understand the complexities organisations face in a rapidly evolving landscape. Our end-to-end transformation services, deep industry expertise, and strategic technology partnerships enable your success.',
  },
  {
    title: 'DoxAI',
    contactLink: 'https://doxai.co/contact/',
    website: 'https://doxai.co',
    description:
      'We deliver digital solutions that help businesses manage data securely, automate operations, and assist with regulatory compliance via technologies such as artificial intelligence (AI), machine learning (ML) and no-code processes.',
  },
];

const SearchFormikContext = ({ onChange }: any): any => {
  const { values } = useFormikContext();

  useEffect(() => {
    onChange(values);
  }, [values]);

  return null;
};

const PartnersHub = (): ReactElement => {
  const [filteredPartnersHub, setFilteredPartnersHub] = useState<any>(PARTNERS);

  const handleFilterChange = (values: any): void => {
    const { 'search-partners-hub': search } = values;

    if (!search) {
      setFilteredPartnersHub(PARTNERS);
      return;
    }

    const filtered = PARTNERS.filter((partner) => {
      const term = search.toLowerCase();
      return (
        partner.title.toLowerCase().includes(term) ||
        partner.description.toLowerCase().includes(term)
      );
    });

    setFilteredPartnersHub(filtered);
  };

  return (
    <>
      <PageHeader
        title="Partners Hub"
        description="Explore our network of trusted service partners"
        customIcon={<Handshake />}
      />
      <Box className="dashboard-page partnershub">
        <HeadTag title="Partners Hub" />

        <Box className="partnershub-wrapper">
          <Formik
            initialValues={{ 'search-partners-hub': '' }}
            onSubmit={() => {
              console.log('test');
            }}
          >
            {({ resetForm }) => (
              <>
                <SearchFormikContext onChange={handleFilterChange} />
                <Grid container className="risk-management-search" spacing={3}>
                  <Grid item sm={6} xs={12}>
                    <AppFormikTextField
                      inputProps={{
                        startAdornment: (
                          <SvgIcon
                            component={Search}
                            inheritViewBox
                            className="view-icon"
                            fontSize="inherit"
                            htmlColor="#76A81F"
                          />
                        ),
                      }}
                      outerLabel={false}
                      placeholder="Search partners by name or service..."
                      name="search-partners-hub"
                    />
                  </Grid>
                  <Grid item sm={6} xs={12} sx={{ alignContent: 'center' }}>
                    <AppPrimaryButtonOutlined
                      title="Clear Filters"
                      onClick={() => {
                        resetForm({
                          values: {
                            'search-partners-hub': '',
                          },
                        });

                        setFilteredPartnersHub(PARTNERS);
                      }}
                      sx={{
                        borderColor: '#e7e7e7 !important',
                        boxShadow: 'none !important',
                        background: 'white !important',
                        color: '#7e7e7e !important',
                        height: '1.4375em !important',
                      }}
                    />
                  </Grid>
                </Grid>
                <Stack direction="column">
                  <Box className="partner-list">
                    {filteredPartnersHub.map((partner: any) => (
                      <ContactPartnerHub
                        key={partner.title}
                        title={partner.title}
                        contactLink={partner.contactLink}
                        website={partner.website}
                        description={partner.description}
                      />
                    ))}
                  </Box>
                </Stack>
              </>
            )}
          </Formik>
        </Box>
      </Box>
    </>
  );
};

export default PartnersHub;
